import { Component } from '@angular/core';
interface WarningSection {
	title?: string;
	items: { text: string }[];
}

@Component({
	selector: 'app-sign-it-disconnect-modal',
	templateUrl: './sign-it-disconnect-modal.component.html',
})
export class SignItDisconnectModalComponent {
	readonly capabilities: WarningSection = {
		title: 'You will no longer be able to:',
		items: [
			{ text: 'Add signing fields to packages' },
			{ text: 'Send draft packages for e-signing' },
		],
	};

	readonly existingPackages: WarningSection = {
		title: 'Important notes about existing packages:',
		items: [
			{ text: 'Sent packages can still be signed and completed' },
			{ text: 'Cancelled packages cannot be resent' },
		],
	};
}
